export const OPENSIDEBAR  = 'OPENSIDEBAR';
export const UPDATEBREADCRUMB = "UPDATEBREADCRUMB";
export const TOURGUIDE="TOURGUIDE";
